export default {"src":"/_next/static/media/frax.b2d98b15.svg","height":570,"width":570,"blurWidth":0,"blurHeight":0};